import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, isDevMode, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, Routes } from '@angular/router';

import { provideTransloco } from '@jsverse/transloco';

import { routes } from './app.routes';
import { authorizationUserInterceptor } from './core/authorization/authorization-user.interceptor';
import { unmappedApiErrorAlertInterceptor } from './core/http/unmapped-api-error-alert.interceptor';
import { eLanguage } from './shared/language/language.enum';
import { TranslocoHttpLoader } from './transloco-loader';

export const createTranslocoConfig = (developmentMode = isDevMode()) => ({
  availableLangs: [eLanguage.EN, eLanguage.ES, eLanguage.PT],
  defaultLang: eLanguage.EN,
  reRenderOnLangChange: true,
  prodMode: !developmentMode,
});

export const createAppProviders = (appRoutes: Routes = routes): NonNullable<ApplicationConfig['providers']> => [
  provideBrowserGlobalErrorListeners(),
  provideRouter(appRoutes),
  provideHttpClient(
    withInterceptors([authorizationUserInterceptor, unmappedApiErrorAlertInterceptor]),
    withInterceptorsFromDi(),
    withFetch(),
  ),
  provideTransloco({
    config: createTranslocoConfig(),
    loader: TranslocoHttpLoader,
  }),
];

export const appConfig: ApplicationConfig = {
  providers: createAppProviders(),
};
